import { v4 as uuid } from 'uuid'

// IMP-13742: the signed key_start is the same for every upload of a campaign, and pasted
// screenshots are all named "image.png": prefix each key with a uuid so uploads never overwrite
// each other (the S3 objects are public-read and already referenced by other briefs).
export const buildS3Key = (keyStart, fileName) => {
  const safeName = (fileName || 'image').replace(/[^\w.-]+/g, '_')
  return `${keyStart}${uuid()}-${safeName}`
}

export const uploadFileToS3 = async (file, s3Config) => {
  const body = new FormData()
  body.append('key', buildS3Key(s3Config.key_start, file.name))
  body.append('Content-Type', file.type)
  body.append('AWSAccessKeyId', s3Config.access_key)
  body.append('policy', s3Config.policy)
  body.append('signature', s3Config.signature)
  body.append('X-Requested-With', 'xhr')
  body.append('success_action_status', '201')
  body.append('acl', 'public-read')
  body.append('file', file)

  const res = await fetch(
    `https://s3-${s3Config.region}.amazonaws.com/${s3Config.bucket}`,
    {
      method: 'POST',
      body,
    }
  )

  const url = new DOMParser()
    .parseFromString(await res.text(), 'application/xml')
    .querySelector('Location').textContent
  return url
}
